import * as firebase from 'firebase'
// import { browserHistory } from 'react-router';

import { LoaderDispatch, messageDispatch } from '../reducers/container/editDispatch';

export function SaveEditProfile(save) {
    return dispatch => {
        console.log(save)
        let file = save.file[0];
        // console.log('SaveEditProfile', file)
        delete save.file;
        dispatch(LoaderDispatch());
        if (save.profile === 'https' || file === undefined) {
            firebase.database().ref('user/' + save.uid + '/').set(save)
                .then((success) => {
                    dispatch(LoaderDispatch());
                    let mess = 'profile updated, you need to login again..!'
                    dispatch(messageDispatch(mess))
                })
                .catch((error) => {
                    dispatch(LoaderDispatch());
                    var errorMessage = error.message;
                    // console.log(errorMessage)
                    dispatch(messageDispatch(errorMessage))
                })
        }
        else {
            var storageRef = firebase.storage().ref().child(`profile/user/${save.profile}/`);
            storageRef.put(file)
                .then((snapshot) => {
                    var snapUrl = snapshot.downloadURL
                    save.profile = snapUrl;
                    firebase.database().ref('user/' + save.uid + '/').set(save)
                        .then((success) => {
                            dispatch(LoaderDispatch());
                            let mess = 'profile updated, you need to login again..!'
                            dispatch(messageDispatch(mess))
                        })
                        .catch((error) => {
                            var errorMessage = error.message;
                            dispatch(LoaderDispatch());
                            // console.log(errorMessage)
                            dispatch(messageDispatch(errorMessage))
                        })
                }).catch((error) => {
                    dispatch(LoaderDispatch());
                    var errorMessage = error.message;
                    // alert(errorMessage)
                    dispatch(messageDispatch(errorMessage))
                })
        }

    }
}



// WEBPACK FOOTER //
// ./src/action/editAction.jsx